export const InstallPermissionAccessTypes = {
  EVERYONE: 'EVERYONE',
  SUPER_ADMINS_AND_AUTHORIZED_INSTALLERS: 'SUPER_ADMINS_AND_AUTHORIZED_INSTALLERS',
  SPECIFIC_USERS_AND_TEAMS: 'SPECIFIC_USERS_AND_TEAMS'
};